import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UserService} from '../../../../services/user-services/user.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {IconComponent} from '../../icons-svgs/icons-svgs.component';
import {DecimalPipe, NgClass, NgFor, NgIf} from '@angular/common';

@Component({
    selector: 'app-accommodation-price-box',
    templateUrl: './accommodation-price-box.component.html',
    styleUrls: ['./accommodation-price-box.component.scss'],
    standalone: true,
    imports: [NgFor, NgIf, NgClass, IconComponent, TranslateModule, DecimalPipe]
})
export class AccommodationPriceBoxComponent implements OnInit {

  @Input() room;
  @Input() isAdmin: boolean =false;
  @Output() updatedValue: EventEmitter<any> = new EventEmitter<any>();

  partnerFees;
  isMobile;

  public pricePartnerSpecificity : any[] = [
    {title: 'COMMON.RENT', price: 0, subItems: ['RESERVATION_MIN'], isEditable: false},
    {title: 'PROCESSES.ACCOMMODATION.DEPOSIT', price: 0, subItems: ['CAUTION_BACK'], isEditable: false},
  ]

  public priceLfSpecificity : any[] = [
    {title: 'PROCESSES.ACCOMMODATION.RESERVATION_FEES', price: 0, subItems: ['GUARANTOR'], isEditable: false},
  ]

  constructor(
    private userService: UserService,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.isMobile = this.userService.isMobileUser;
    this.priceLfSpecificity[0].price = this.room.property_price.reservation_fees;
    this.pricePartnerSpecificity[0].price = this.room.property_price.price;
    this.pricePartnerSpecificity[1].price = this.room.property_price.deposit;
    this.pricePartnerSpecificity.push({
      title: 'PROCESSES.ACCOMMODATION.PARTNER_FEES',
      price: this.room.partner_fees,
      subItems: ['PARTNER_FEES'],
      isEditable: true,
      isPartnerFee: true
    });
  }

  // Add un switch sur type si on modifie plusieurs values
  public change(type, event):void {
    this.partnerFees = event.target.innerText;
    this.partnerFees = this.partnerFees.replace('€', '');
  }

  public updateRoom() :void {
    this.updatedValue.emit(parseInt(this.partnerFees))
  }

  gotoHelpCenter() {
    if (this.translateService.currentLang == 'fr') {
      window.open('https://help.livin-france.com/knowledge/il-est-inscrit-provisions-sur-charges-dans-mon-contrat-quest-ce-que-cela-signifie', '_blank', 'noopener,noreferrer')
    } else {
      window.open('https://help.livin-france.com/en/knowledge/my-charges-are-provisions-sur-charges-what-does-it-means', '_blank', 'noopener,noreferrer')
    }
  }


}
